/* eslint react/require-default-props: 0 */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { connect } from 'react-redux';

import { actions as reqMemberInvitation } from '../../redux/communities/reqMemberInvitation';
import { reqMemberInvitationErrorSelector } from '../../redux/communities/selectors/selectors';
import { uiFormInProgressSelector } from '../../redux/ui/selectors';
import { privacyCountriesSelector } from '../../redux/data/selectors';
import { COMMON_ERROR_MESSAGES, AUTH } from '../../constants/strings';

import InviteForm from '../CirclesLayout/InviteForm';
import TextInput from '../TextInput';

const UserInviteForm = ({
  error,
  sendInvite,
  formInProgress,
  formatMessage,
  clearErrors,
  communityId,
  ...props
}) => {
  const handleErrors = () => {
    if (!error) return '';
    const errorMessage = {
      invalid: formatMessage(COMMON_ERROR_MESSAGES.emailAndPhoneError),
      present: formatMessage(COMMON_ERROR_MESSAGES.alreadyUsed),
    };
    const code = get(error, 'code');
    return errorMessage
      ? errorMessage[code]
      : formatMessage(COMMON_ERROR_MESSAGES.error);
  };
  const [isSend, setIsSend] = useState(false);
  const validateForm = ({ login }) => !!login === true && !isSend;
  const handleSubmit = data => {
    const { login } = data;
    sendInvite({ login, communityId });
    setIsSend(true);
  };

  return (
    <InviteForm
      onSubmit={handleSubmit}
      onError={handleErrors}
      isFormValid={validateForm}
      inviteMessage={`${formatMessage(
        AUTH.titles.invitationLinkDesc,
      )} ${formatMessage(AUTH.actions.expiredToken.textTitle)}`}
      formatMessage={formatMessage}
      {...{ error }}
      {...props}
      hideTerms
    >
      <TextInput
        styleName="invite-input"
        className="mb3 mt3"
        id="invite-login"
        label={formatMessage(AUTH.fields.loginPlaceholder)}
        name="login"
        placeholder={formatMessage(AUTH.fields.loginPlaceholder)}
        required
        rounded
        type="text"
        value={formInProgress.login}
        onChange={error && clearErrors}
      />
    </InviteForm>
  );
};

UserInviteForm.propTypes = {
  sendInvite: PropTypes.func,
  clearErrors: PropTypes.func,
  error: PropTypes.object,
  formInProgress: PropTypes.object,
  formatMessage: PropTypes.func,
  communityId: PropTypes.number,
};

const mapStateToProps = state => ({
  error: reqMemberInvitationErrorSelector(state),
  formInProgress: uiFormInProgressSelector(state),
  countries: privacyCountriesSelector(state),
});

const mapDispatchToProps = {
  clearErrors: reqMemberInvitation.clear,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UserInviteForm);



// WEBPACK FOOTER //
// ./src/components/UserInviteForm/index.jsx